import { useMemo } from 'react';

import { Controller } from '../types';
import { OrderController, OrderControllerId } from './types';

export const useOrderControl = (
  getControl: (controlId: string) => Controller | undefined
): OrderController => {
  const fallback: OrderController = useMemo(() => {
    return {
      id: OrderControllerId,
      handlers: {
        set: () => {
          /**NOOP */
        },
      },
      hasControl: () => false,
    };
  }, []);

  return (getControl(OrderControllerId) as OrderController) || fallback;
};
